import { render, staticRenderFns } from "./fontIconComm.vue?vue&type=template&id=0bece588&scoped=true"
import script from "./fontIconComm.vue?vue&type=script&lang=js"
export * from "./fontIconComm.vue?vue&type=script&lang=js"
import style0 from "./fontIconComm.vue?vue&type=style&index=0&id=0bece588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bece588",
  null
  
)

export default component.exports